if (!customElements.get("featured-products")) {
  class FeaturedProducts extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    initSlider() {
      if (this.dataset.layout !== "slider") return;
      const sliderEl = this.querySelector(".featured-products__slider");
      if (!sliderEl || this.swiper) return;

      const prevEl = this.querySelector(".featured-products__arrow--prev");
      const nextEl = this.querySelector(".featured-products__arrow--next");
      const paginationEl = this.querySelector(".featured-products__pagination");

      this.swiper = new Swiper(sliderEl, {
        slidesPerView: 1.2,
        spaceBetween: 16,

        pagination: {
          el: paginationEl,
          clickable: true,
        },

        navigation: {
          prevEl,
          nextEl,
          disabledClass: "swiper-button-disabled",
        },

        breakpoints: {
          768: {
            slidesPerView: 2.2,
          },
          1023: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
        },
      });
    }

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define("featured-products", FeaturedProducts);
}
